import { useContext, useEffect } from 'react';
import { ConfirmationModalContext } from '../contexts/ConfirmationProvider';

const ConfirmationModal = () => {
  // confirmation context
  const { modal, showModal } = useContext(ConfirmationModalContext);
  const { title, message, show, action, okBtnText, cancelBtnText } = modal;
  useEffect(() => {
    if (show) {
      (document.getElementById('confirmation_modal') as HTMLFormElement)?.showModal();
    } else {
      (document.getElementById('confirmation_modal') as HTMLFormElement)?.close();
    }
  }, [show]);

  useEffect(() => {
    const handleEsc = (event: { key: string }) => {
      if (event.key === 'Escape') {
        CloseModal();
      }
    };
    window.addEventListener('keydown', handleEsc);

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, []);

  const CloseModal = () => {
    showModal({ title: '', show: false });
  };

  const OnAction = () => {
    if (action) {
      action();
    }
    CloseModal();
  };
  return (
    <dialog id="confirmation_modal" className="modal ">
      <div className="modal-box max-w-md p-2 sm:p-8 ">
        <div className="flex flex-row justify-between">
          <h3 className="font-bold text-2xl text-primary text-nowrap">{title}</h3>
        </div>
        <div className="divider divider-primary m-0" />
        <div className=" text-center">{message}</div>

        <div className="flex justify-end m-2 gap-2 mt-6">
          {action !== null ? (
            <div className="w-full">
              <button className="btn btn-success btn-outline w-full" onClick={OnAction}>
                {okBtnText === undefined ? 'OK' : okBtnText}
              </button>
            </div>
          ) : null}
          <div className="w-full">
            <button className="btn btn-error btn-outline w-full" onClick={CloseModal}>
              {cancelBtnText === undefined ? 'Cancel' : cancelBtnText}
            </button>
          </div>
        </div>
      </div>
      {/* weird way to have the whole backdrop to be the close modal button */}
      <form method="dialog" className="modal-backdrop absolute w-full h-full" onClick={CloseModal}>
        <button>close</button>
      </form>
    </dialog>
  );
};

export default ConfirmationModal;
